module.exports = ":host /deep/ .widget-19-post{height:237px;background:#00a79a;display:flex;align-items:center}\n"